(() => {
  const dialog = document.getElementById('EkImageViewer');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const canvas = dialog.querySelector('.ekiv-canvas');
  const image = dialog.querySelector('.ekiv-image');
  const status = dialog.querySelector('.ekiv-status');
  const controls = Object.fromEntries([...dialog.querySelectorAll('[data-ekiv]')].map(b => [b.dataset.ekiv, b]));
  const points = new Map();
  let items = [], index = 0, scale = 1, x = 0, y = 0, baseWidth = 0, baseHeight = 0;
  let opener, oldOverflow, galleryDown, tapStart, lastTap = 0;
  const visible = el => !!el && !el.closest('[hidden]') && el.getClientRects().length > 0;
  const source = img => {
    const media = img.closest('.media');
    let value = media?.getAttribute('data-zoom-image') || media?.getAttribute('href');
    if (!value || /^(javascript:|#)/i.test(value)) value = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-srcset')?.split(',').pop()?.trim().split(/\s+/)[0];
    if (!value) return '';
    const url = new URL(value, location.href);
    if (!/^https?:$/.test(url.protocol)) return '';
    if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(url.href)) {
      ['width', 'height', 'crop'].forEach(key => url.searchParams.delete(key));
      url.pathname = url.pathname.replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[a-z]+$)/i, '');
    }
    return url.href;
  };
  function paint() {
    const maxX = Math.max(0, (baseWidth * scale - canvas.clientWidth) / 2);
    const maxY = Math.max(0, (baseHeight * scale - canvas.clientHeight) / 2);
    x = Math.max(-maxX, Math.min(maxX, x));
    y = Math.max(-maxY, Math.min(maxY, y));
    image.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(${scale})`;
    controls.reset.textContent = `${Math.round(scale * 100)}%`;
    controls.in.disabled = scale >= 4 || image.hidden;
    controls.out.disabled = scale <= 1 || image.hidden;
    canvas.classList.toggle('is-zoomed', scale > 1);
  }
  function zoom(next, px = 0, py = 0) {
    if (image.hidden) return;
    next = Math.max(1, Math.min(4, next));
    const ratio = next / scale;
    x = px - (px - x) * ratio;
    y = py - (py - y) * ratio;
    scale = next;
    paint();
  }
  function fit() {
    if (!dialog.open || !image.naturalWidth) return;
    const ratio = Math.min(1, Math.max(1, canvas.clientWidth - 32) / image.naturalWidth, Math.max(1, canvas.clientHeight - 32) / image.naturalHeight);
    baseWidth = image.naturalWidth * ratio;
    baseHeight = image.naturalHeight * ratio;
    image.style.width = `${baseWidth}px`;
    image.style.height = `${baseHeight}px`;
    image.hidden = false;
    status.textContent = '';
    scale = 1; x = 0; y = 0;
    paint();
  }
  function show(next) {
    index = (next + items.length) % items.length;
    points.clear(); scale = 1; x = 0; y = 0;
    image.hidden = true;
    status.textContent = dialog.dataset.loadingLabel;
    image.alt = items[index].alt;
    image.src = items[index].src;
    dialog.querySelector('.ekiv-count').textContent = `${index + 1} / ${items.length}`;
    controls.previous.disabled = controls.next.disabled = items.length < 2;
    paint();
    if (image.complete && image.naturalWidth) fit();
  }
  function open(trigger) {
    const root = trigger.closest('.ekx-stage, [data-image-gallery-main]') || trigger.closest('.productView-images');
    if (!root) return;
    const combo = root.matches('.ekx-stage');
    const selected = combo ? root.querySelector('.ekx-slide:not([hidden]) img') : trigger.querySelector('img[data-main-image]') || root.querySelector('.slick-current img[data-main-image]') || root.querySelector('img[data-main-image]');
    if (!selected) return;
    const group = selected.closest('.ekx-slide')?.dataset.group;
    const gallery = [...root.querySelectorAll(combo ? '.ekx-slide img' : 'img[data-main-image]')].filter(img => combo ? img.closest('.ekx-slide').dataset.group === group : !img.closest('.slick-cloned'));
    items = gallery.map(img => ({src: source(img), alt: img.alt || ''})).filter(item => item.src);
    if (!items.length) return;
    const selectedIndex = Math.max(0, items.findIndex(item => item.src === source(selected)));
    opener = trigger;
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    show(selectedIndex);
    controls.close.focus({preventScroll:true});
  }
  function setup() {
    document.querySelectorAll('.productView-image .media, .ekx-slide').forEach(el => {
      if (!el.querySelector('img[data-main-image], .ekx-slide > img') && !(el.matches('.ekx-slide') && el.querySelector('img'))) return;
      el.dataset.ekivTrigger = 'true';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', dialog.dataset.openLabel);
      el.setAttribute('aria-haspopup', 'dialog');
    });
    document.querySelectorAll('.productView-iconZoom').forEach(el => {
      el.dataset.ekivTrigger = 'true';
      el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', dialog.dataset.openLabel);
    });
    document.querySelectorAll('.ekx-stage').forEach(stage => {
      if (stage.querySelector('.ekiv-open')) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ekiv-open'; button.dataset.ekivTrigger = 'true';
      button.setAttribute('aria-label', dialog.dataset.openLabel); button.setAttribute('aria-haspopup', 'dialog');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6m-3-3v6"/></svg>';
      stage.append(button);
    });
  }
  function triggerFor(target) {
    return target.closest('[data-ekiv-trigger], .productView-image .media, .ekx-slide, .productView-iconZoom');
  }
  document.addEventListener('pointerdown', e => {
    if (!dialog.open && triggerFor(e.target)) galleryDown = {x:e.clientX,y:e.clientY};
  }, true);
  document.addEventListener('click', e => {
    if (dialog.open) return;
    const trigger = triggerFor(e.target);
    if (!trigger || trigger.closest('.ekx-thumb') || e.target.closest('.ekx-arrow')) return;
    if (!trigger.matches('.productView-iconZoom, .ekiv-open') && !trigger.querySelector('img')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const dragged = e.detail && galleryDown && Math.hypot(e.clientX-galleryDown.x,e.clientY-galleryDown.y)>10;
    galleryDown = null;
    if (!dragged) open(trigger);
  }, true);
  document.addEventListener('keydown', e => {
    if (dialog.open) return;
    const trigger = triggerFor(e.target);
    if (trigger && ['Enter',' '].includes(e.key)) {e.preventDefault();e.stopImmediatePropagation();open(trigger);}
  }, true);
  dialog.addEventListener('click', e => {
    const action = e.target.closest('[data-ekiv]')?.dataset.ekiv;
    if (action === 'close') dialog.close();
    if (action === 'in') zoom(scale * 1.5);
    if (action === 'out') zoom(scale / 1.5);
    if (action === 'reset') zoom(1);
    if (action === 'previous') show(index-1);
    if (action === 'next') show(index+1);
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    points.clear(); canvas.classList.remove('is-dragging');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  dialog.addEventListener('keydown', e => {
    const actions = {ArrowLeft:()=>show(index-1),ArrowRight:()=>show(index+1),'+':()=>zoom(scale*1.5),'=':()=>zoom(scale*1.5),'-':()=>zoom(scale/1.5),'0':()=>zoom(1)};
    if (actions[e.key]) {e.preventDefault();e.stopPropagation();actions[e.key]();}
  });
  image.addEventListener('load', fit);
  image.addEventListener('error', () => {image.hidden=true;status.textContent=dialog.dataset.errorLabel;paint();});
  const center = p => {const r=canvas.getBoundingClientRect();return {x:p.x-r.left-r.width/2,y:p.y-r.top-r.height/2};};
  const pair = () => {const p=[...points.values()];return {x:(p[0].x+p[1].x)/2,y:(p[0].y+p[1].y)/2,d:Math.hypot(p[0].x-p[1].x,p[0].y-p[1].y)};};
  canvas.addEventListener('pointerdown', e => {
    if (image.hidden || e.button>0) return;
    points.set(e.pointerId,{x:e.clientX,y:e.clientY});
    tapStart=points.size===1?{x:e.clientX,y:e.clientY,time:Date.now()}:null;
    canvas.setPointerCapture(e.pointerId);canvas.classList.add('is-dragging');
  });
  canvas.addEventListener('pointermove', e => {
    if (!points.has(e.pointerId)) return;
    const old=points.get(e.pointerId), before=points.size===2?pair():null;
    points.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if (before) {
      const after=pair(), origin=center(before);
      if(before.d>0) zoom(scale*after.d/before.d,origin.x,origin.y);
      x+=after.x-before.x;y+=after.y-before.y;
    } else if(scale>1) {x+=e.clientX-old.x;y+=e.clientY-old.y;}
    if(tapStart&&Math.hypot(e.clientX-tapStart.x,e.clientY-tapStart.y)>8)tapStart=null;
    paint();
  });
  function release(e) {
    if(e.type==='pointerup'&&e.pointerType==='touch'&&tapStart&&Date.now()-tapStart.time<300){
      const now=Date.now();if(now-lastTap<300){const p=center({x:e.clientX,y:e.clientY});zoom(scale>1?1:2,p.x,p.y);lastTap=0;}else lastTap=now;
    }
    points.delete(e.pointerId);tapStart=null;
    if(!points.size)canvas.classList.remove('is-dragging');
  }
  canvas.addEventListener('pointerup',release);canvas.addEventListener('pointercancel',release);
  canvas.addEventListener('dblclick',e=>{const p=center({x:e.clientX,y:e.clientY});zoom(scale>1?1:2,p.x,p.y);});
  canvas.addEventListener('wheel',e=>{e.preventDefault();const p=center({x:e.clientX,y:e.clientY});zoom(scale*Math.exp(-e.deltaY*.002),p.x,p.y);},{passive:false});
  window.addEventListener('resize',()=>{if(dialog.open)fit();});
  document.addEventListener('shopify:section:load',setup);
  setup();
})();
